import Picker from '@emoji-mart/react';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors'

interface Props {
    handleEmojiSelect: (e: any) => void;
}

const Emojis = (props: Props) => {
    const IsDarkMode = useSelector(selector.isDarkMode);
    return (
        <Picker
            emojiSize={16}
            onEmojiSelect={(e: any) => props.handleEmojiSelect(e)}
            theme={IsDarkMode ? 'dark' : 'light'}
        />
    );
}

export default Emojis;
